import PlaceForm from "/components/PlaceForm";
import styles from "/components/PlaceForm/styles.module.css";

export default function NewPlace({
  errors = {},
}) {
  return (
    <div className={styles.fullFormWrapper}>
      <h2>New place</h2>

      <PlaceForm
        action="/places"
        method="POST"
        errors={errors}
      />
    </div>
  );
}
